import axios, {AxiosRequestConfig} from 'axios'
import {CmsApiClient} from "@/_global/api_clients/CmsApiClient";

export class DeliousApiClientLocal {

    public static async getUser() {
        return (await axios.get("./data/delious/delious_user.json")).data || {};
    }

    public static async getItemSearchList(storeId: number, generationId: number) {
        return (await axios.get("./data/delious/delious_item_list.json")).data || {};
    }

    public static async getStores() {
        return (await axios.get("./data/delious/delious_store_list.json")).data || {};
    }

    public static async getGenerations() {
        return (await axios.get("./data/delious/delious_gen_list.json")).data || {};
    }

    public static async getItemDetailList( storeId: number, periodId: number ) {
        return (await axios.get("./data/delious/delious_item_detail_list.json")).data || {};
    }

    public static async getPluClassList( storeId: number, level: string ) {
        return (await axios.get("./data/delious/delious_plu_class_list.json")).data || {};
    }
}

